export default class {
  init() {
    const $elements = $("section.hero-carousel .slick-slider");

    if ($elements.length) {
      (async () => {
        await import("slick-carousel");

        $elements
          .on("init", () => {
            window.App.aos.refreshHard();
          })
          .slick({
            centerPadding: "120px",
            centerMode: true,
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="14" viewBox="0 0 28 14"><path fill="currentColor" d="M20.293.293a.999.999 0 000 1.414L24.586 6H1a1 1 0 000 2h23.586l-4.293 4.293a.999.999 0 101.414 1.414l5.999-5.999a1 1 0 000-1.416L21.707.293a.999.999 0 00-1.414 0z"/></svg></button>',
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="14" viewBox="0 0 28 14"><path fill="currentColor" d="M7.707 13.707a.999.999 0 000-1.414L3.414 8H27a1 1 0 000-2H3.414l4.293-4.293A.999.999 0 106.293.293l-5.999 6a1 1 0 000 1.415l5.999 6a.999.999 0 001.414 0z"/></svg></button>',
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  centerMode: false,
                  dots: true,
                  arrows: false,
                },
              },
            ],
          });
      })();
    }
  }
}
